module.exports = __webpack_public_path__ + "static/img/mp.999a98e3.svg";